<template>
  <div class="space-y-7 mt-7">
    <div class="flex flex-col md:flex-row">
      <div class="flex flex-col text-left">
        <h6 class="font-bold text-black">Detractors</h6>
        <div class="line">
          <div v-for="number in 7" :key="number" class="circle-container flex flex-col items-center justify-center">
            <CircleNumber :number="(number - 1).toString()" :color="getCircleColor(number)" :size="30" />
          </div>
        </div>
      </div>
      <div class="flex flex-col text-left mt-3 md:mt-0">
        <h6 class="font-bold text-black">Passives</h6>
        <div class="line">
          <div v-for="number in 2" :key="number" class="circle-container flex flex-col items-center justify-center">
            <CircleNumber :number="(number + 6).toString()" :color="getCircleColor(number + 7)" :size="30" />
          </div>
        </div>
      </div>
      <div class="flex flex-col text-left mt-3 md:mt-0">
        <h6 class="font-bold text-black">Promoters</h6>
        <div class="line">
          <div v-for="number in 2" :key="number" class="circle-container flex flex-col items-center justify-center">
            <CircleNumber :number="(number + 8).toString()" :color="getCircleColor(number + 9)" :size="30" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleNumber from './CircleNumber.vue'

export default {
  components: {
    CircleNumber
  },
  methods: {
    getCircleColor(number) {
      if (number < 8) {
        return 'red'
      } else if (number < 10) {
        return 'yellow'
      } else {
        return 'green'
      }
    }
  }
}
</script>

<style scoped>
.line {
  display: flex;
  justify-content: space-between;
}

.circle-container {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/schema/ScoreSchema.vue